import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Heart, CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | failed
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    let attempts = 0;
    let active = true;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (!active) return;
        if (data.payment_status === "paid") { setInfo(data); setState("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("failed"); return; }
      } catch { /* keep trying */ }
      attempts += 1;
      if (attempts < 15) setTimeout(poll, 2000);
      else setState("failed");
    };
    poll();
    return () => { active = false; };
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#0a0e17] grid place-items-center px-4">
      <div data-testid="payment-success-page" className="max-w-md w-full text-center rounded-2xl border border-rose-900/40 bg-slate-950 p-10">
        {state === "checking" && (
          <>
            <Loader2 className="mx-auto text-rose-400 animate-spin" size={48} />
            <h1 className="font-display text-2xl font-bold mt-5 text-slate-50">Confermiamo il pagamento…</h1>
            <p className="text-slate-400 mt-2 text-sm">Un istante, stiamo scrivendo il tuo amore sul muro.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <div className="relative inline-block">
              <CheckCircle2 className="mx-auto text-emerald-400" size={56} />
              <Heart className="absolute -right-2 -top-1 text-rose-500 fill-rose-500 animate-heart-pulse" size={22} />
            </div>
            <h1 className="font-display text-3xl font-extrabold mt-5 text-slate-50">Amore eternato ❤️</h1>
            <p className="text-slate-300 mt-2">
              {info?.pixel_count ? `${info.pixel_count} pixel sono` : "I tuoi pixel sono"} ora tuoi per sempre sul Muro dei Ti Amo.
            </p>
            <Button data-testid="back-to-wall-button" onClick={() => navigate("/")}
              className="mt-6 bg-rose-600 hover:bg-rose-500 rounded-full h-12 px-8 font-semibold">
              Guarda la tua dedica sul muro
            </Button>
          </>
        )}
        {state === "failed" && (
          <>
            <XCircle className="mx-auto text-rose-500" size={52} />
            <h1 className="font-display text-2xl font-bold mt-5 text-slate-50">Pagamento non confermato</h1>
            <p className="text-slate-400 mt-2 text-sm">Non siamo riusciti a confermare il pagamento. Se sei stato addebitato, i pixel appariranno a breve.</p>
            <Button onClick={() => navigate("/")} className="mt-6 bg-slate-800 hover:bg-slate-700 rounded-full h-11 px-6">Torna al muro</Button>
          </>
        )}
      </div>
    </div>
  );
}
